/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Admin resource route shells, two-panel item layout, and
 * activate/archive/delete chrome.
 */
import {TwoPanelLayoutComponent} from '../directives/two-panel-layout.component';
import {SignalAdminResourceContextActionsComponent} from './signal-admin-resource-context-actions.component';
import {SignalAdminResourceListComponent} from './signal-admin-resource-list.component';
import {SignalAdminResourceSpecifyIdModalComponent} from './signal-admin-resource-specify-id-modal.component';
import {SignalAdminResourceTitleComponent} from './signal-admin-resource-title.component';

export const ADMIN_RESOURCE_PAGES = [
  TwoPanelLayoutComponent,
  SignalAdminResourceContextActionsComponent,
  SignalAdminResourceSpecifyIdModalComponent,
  SignalAdminResourceTitleComponent,
  SignalAdminResourceListComponent
];
